import { UUIEvent, UUISelectableEvent } from '@umbraco-ui/uui-base/lib/events';
import { defineElement } from '@umbraco-ui/uui-base/lib/registration';
import { LitElement, html, css } from 'lit';
import { property, queryAssignedElements } from 'lit/decorators.js';
import { LabelMixin } from '@umbraco-ui/uui-base/lib/mixins';

var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
class UUIColorSwatchesEvent extends UUIEvent {
  constructor(evName, eventInit = {}) {
    super(evName, __spreadValues(__spreadValues({}, { bubbles: true }), eventInit));
  }
}
UUIColorSwatchesEvent.CHANGE = "change";

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let UUIColorSwatchesElement = class extends LabelMixin("label", LitElement) {
  constructor() {
    super();
    this.value = "";
    this._onSelected = (event) => {
      const target = event.target;
      if (!this.swatches.includes(target))
        return;
      if (this._selectedElement) {
        this._selectedElement.selected = false;
        this._selectedElement.active = false;
        this._selectedElement = void 0;
      }
      this._selectedElement = target;
      this._activeElement = this._selectedElement;
      this.value = this._selectedElement.value || "";
      this.dispatchEvent(new UUIColorSwatchesEvent(UUIColorSwatchesEvent.CHANGE));
    };
    this._onDeselected = (event) => {
      const target = event.target;
      if (!this.swatches.includes(target))
        return;
      if (this._activeElement === target) {
        this._activeElement = void 0;
      }
      if (this._selectedElement === target) {
        this._selectedElement.selected = false;
        this._selectedElement.active = false;
        this._selectedElement = void 0;
        this.value = "";
        this.dispatchEvent(
          new UUIColorSwatchesEvent(UUIColorSwatchesEvent.CHANGE)
        );
      }
    };
    this.addEventListener(UUISelectableEvent.SELECTED, this._onSelected);
    this.addEventListener(UUISelectableEvent.DESELECTED, this._onDeselected);
  }
  get _activeElement() {
    return this.__activeElement;
  }
  set _activeElement(el) {
    if (this.__activeElement) {
      this.__activeElement.active = false;
    }
    if (el) {
      el.active = true;
      this.__activeElement = el;
    }
  }
  connectedCallback() {
    super.connectedCallback();
    this.setAttribute("role", "radiogroup");
    this.setAttribute("aria-label", this.label);
  }
  willUpdate(_changedProperties) {
    if (_changedProperties.has("label")) {
      this.setAttribute("aria-label", this.label);
    }
  }
  _handleSlotChange() {
    if (!this.swatches || this.swatches.length === 0)
      return;
    this.swatches.forEach((swatch) => {
      var _a;
      swatch.setAttribute("selectable", "selectable");
      swatch.setAttribute("aria-checked", "false");
      swatch.setAttribute("role", "radio");
      if (this.value !== "" && ((_a = swatch.color) == null ? void 0 : _a.isEqual(this.value))) {
        swatch.selected = true;
        swatch.setAttribute("aria-checked", "true");
        this._selectedElement = swatch;
        this._activeElement = this._selectedElement;
      }
    });
  }
  /**
   * Deselects all swatches.
   *
   * @memberof UUIColorSwatchesElement
   */
  resetSelection() {
    this.swatches.forEach((swatch) => {
      swatch.selected = false;
      swatch.active = false;
      swatch.selectable = true;
    });
    this._activeElement = void 0;
    this._selectedElement = void 0;
    this.value = "";
  }
  render() {
    return html`<slot @slotchange=${this._handleSlotChange}></slot>`;
  }
};
UUIColorSwatchesElement.styles = [
  css`
      :host {
        display: flex;
        flex-wrap: wrap;
        gap: 0.4rem;
      }
    `
];
__decorateClass([
  property()
], UUIColorSwatchesElement.prototype, "value", 2);
__decorateClass([
  queryAssignedElements({ selector: "uui-color-swatch" })
], UUIColorSwatchesElement.prototype, "swatches", 2);
UUIColorSwatchesElement = __decorateClass([
  defineElement("uui-color-swatches")
], UUIColorSwatchesElement);

export { UUIColorSwatchesElement, UUIColorSwatchesEvent };
